var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showInput
      ? _c("div", { staticClass: "router_box" }, [
          _c("b", [_vm._v("路线")]),
          _c(
            "div",
            { staticStyle: { margin: "0.2rem 0rem", width: "9.44rem" } },
            [
              _c(
                "p",
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      model: {
                        value: _vm.spotData.planType,
                        callback: function ($$v) {
                          _vm.$set(_vm.spotData, "planType", $$v)
                        },
                        expression: "spotData.planType",
                      },
                    },
                    [_vm._v("有相对准确的日期")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 2 },
                      model: {
                        value: _vm.spotData.planType,
                        callback: function ($$v) {
                          _vm.$set(_vm.spotData, "planType", $$v)
                        },
                        expression: "spotData.planType",
                      },
                    },
                    [_vm._v("有大致日期范围")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "vague" }, [
                _c("p", [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.spotData.planType == 1,
                          expression: "spotData.planType==1",
                        },
                      ],
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "dateBox",
                        staticStyle: { width: "2.32rem" },
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          size: "mini",
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        model: {
                          value: _vm.spotData.inquiryPlan.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.spotData.inquiryPlan, "dateRange", $$v)
                          },
                          expression: "spotData.inquiryPlan.dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.spotData.planType == 2,
                          expression: "spotData.planType==2",
                        },
                      ],
                    },
                    [
                      _c(
                        "span",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "1.3rem" },
                              attrs: { placeholder: "请选择", size: "mini" },
                              model: {
                                value: _vm.spotData.inquiryPlan.useDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.spotData.inquiryPlan,
                                    "useDate",
                                    $$v
                                  )
                                },
                                expression: "spotData.inquiryPlan.useDate",
                              },
                            },
                            _vm._l(_vm.yearOption, function (i) {
                              return _c("el-option", {
                                key: i,
                                attrs: { label: i + "年", value: i },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "1.3rem" },
                              attrs: { placeholder: "请选择", size: "mini" },
                              model: {
                                value: _vm.spotData.inquiryPlan.useMonth,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.spotData.inquiryPlan,
                                    "useMonth",
                                    $$v
                                  )
                                },
                                expression: "spotData.inquiryPlan.useMonth",
                              },
                            },
                            _vm._l(12, function (i) {
                              return _c("el-option", {
                                key: i,
                                attrs: { label: i + "月", value: i },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c("b", [_vm._v("用 ")]),
                      _c(
                        "span",
                        [
                          _c("el-input", {
                            staticStyle: { width: "80px" },
                            attrs: { placeholder: "请填写", size: "mini" },
                            on: {
                              input: function ($event) {
                                _vm.spotData.inquiryPlan.useDay =
                                  _vm.spotData.inquiryPlan.useDay.replace(
                                    /[^\d]/g,
                                    ""
                                  )
                              },
                            },
                            model: {
                              value: _vm.spotData.inquiryPlan.useDay,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.spotData.inquiryPlan,
                                  "useDay",
                                  $$v
                                )
                              },
                              expression: "spotData.inquiryPlan.useDay",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("b", [_vm._v("天 ")]),
                    ]
                  ),
                  _c(
                    "span",
                    [
                      _c("el-input", {
                        staticStyle: { width: "5rem" },
                        attrs: { placeholder: "请输入内容", size: "mini" },
                        model: {
                          value: _vm.spotData.inquiryPlan.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.spotData.inquiryPlan, "remark", $$v)
                          },
                          expression: "spotData.inquiryPlan.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("p", [
                  _c("span", [_vm._v("开始城市")]),
                  _c(
                    "span",
                    [
                      _c("city-autocomplete", {
                        attrs: {
                          obj: _vm.spotData.inquiryPlan.cityObj,
                          width: "width: 1.5rem;",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("span", [_vm._v("结束城市")]),
                  _c(
                    "span",
                    [
                      _c("city-autocomplete", {
                        attrs: {
                          obj: _vm.spotData.inquiryPlan.endCityObj,
                          width: "width: 1.5rem;",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("span", [_vm._v("其他途径城市")]),
                  _c(
                    "span",
                    [
                      _c("city-autocomplete", {
                        attrs: {
                          obj: _vm.spotData.inquiryPlan.otherCityObj,
                          width: "width: 1.5rem;",
                          action: false,
                        },
                        on: {
                          handleSelect: function ($event) {
                            return _vm.handleSelect(
                              $event,
                              _vm.spotData.inquiryPlan
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { staticClass: "tag_box" },
                    _vm._l(
                      _vm.spotData.inquiryPlan.channelCities,
                      function (tag, ind) {
                        return _c(
                          "el-tag",
                          {
                            key: ind,
                            staticStyle: {
                              "margin-right": "0.05rem",
                              height: "0.4rem",
                              "line-height": "0.4rem",
                            },
                            attrs: { closable: "", type: "warning" },
                            on: {
                              close: function ($event) {
                                return _vm.delUseDate(
                                  _vm.spotData.inquiryPlan.channelCities,
                                  ind
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(tag.cityName) + " ")]
                        )
                      }
                    ),
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ])
      : _c("div"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }